var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPublicTransport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#039"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.875 5.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.875,
    cy: 0.875,
    r: 0.875,
    transform: "translate(2.625 10.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.875,
    cy: 0.875,
    r: 0.875,
    transform: "translate(7.875 10.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 0.875,
    transform: "translate(4.375 4.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.25,38V29.25a2.325,2.325,0,0,0-2.625-2.625h-2.94l1.4-1.75h1.54V24h-7v.875h1.54l1.4,1.75h-2.94A2.325,2.325,0,0,0,36,29.25V38h1.917l-.437.875h-.6v.875h.167l-.437.875H36V41.5H48.25v-.875h-.6l-.437-.875h.167v-.875h-.6L46.333,38ZM42.965,24.875l-.84,1.05-.84-1.05ZM38.625,27.5h7c1.26,0,1.75.491,1.75,1.75v3.5h-10.5v-3.5C36.875,27.991,37.366,27.5,38.625,27.5Zm-1.75,6.125h10.5v3.5h-10.5Zm9.792,7H37.583l.438-.875H46.23Zm-.875-1.75H38.458L38.9,38h6.459Z",
    transform: "translate(-36 -24)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublicTransport);
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28'%3e%3ccircle cx='14' cy='14' r='14' fill='%23039'/%3e%3cg transform='translate(7.875 5.25)'%3e%3ccircle cx='0.875' cy='0.875' r='0.875' transform='translate(2.625 10.5)' fill='%23fff'/%3e%3ccircle cx='0.875' cy='0.875' r='0.875' transform='translate(7.875 10.5)' fill='%23fff'/%3e%3crect width='3.5' height='0.875' transform='translate(4.375 4.375)' fill='%23fff'/%3e%3cpath d='M48.25,38V29.25a2.325,2.325,0,0,0-2.625-2.625h-2.94l1.4-1.75h1.54V24h-7v.875h1.54l1.4,1.75h-2.94A2.325,2.325,0,0,0,36,29.25V38h1.917l-.437.875h-.6v.875h.167l-.437.875H36V41.5H48.25v-.875h-.6l-.437-.875h.167v-.875h-.6L46.333,38ZM42.965,24.875l-.84,1.05-.84-1.05ZM38.625,27.5h7c1.26,0,1.75.491,1.75,1.75v3.5h-10.5v-3.5C36.875,27.991,37.366,27.5,38.625,27.5Zm-1.75,6.125h10.5v3.5h-10.5Zm9.792,7H37.583l.438-.875H46.23Zm-.875-1.75H38.458L38.9,38h6.459Z' transform='translate(-36 -24)' fill='%23fff'/%3e%3c/g%3e%3c/svg%3e";
export { ForwardRef as ReactComponent };